// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2022-10-25 12:05:30 +0200 (Tue, 25 Oct 2022) $
//  Author    : Dirk Rothe
//  Worker    : $Author: s.bock $
//  Revision  : $Rev: 130047 $
//  Purpose   : fulltext package
// =============================================================================

export {sagas} from './sagas'

import * as reducers from './reducers'
export {reducers}

import * as actions from './actions'
export {actions}

import * as views from './views'
export {views}

export const parts = true
export const columns = true
export const templates = true
export const jobs = true

// VLM access
export const selectors = {
  fulltextAdminShowViewer: root =>
    root.ui.byId['Part/FulltextView/FulltextAdminOptions'].value.showViewer,
}
